import { APP_ENV } from '@my/config';
import * as clerk from './clerk-auth';
import { Platform } from 'react-native'

export { useSignIn, useClerkSSO } from './clerk-auth';

const getSearchParams = () => new URLSearchParams(window.location.search);
const useOverrideUserId = () => {
  if (APP_ENV.TZA_ENV !== 'development') {
    return null;
  }

  let userId: string | null = null;
  const searchParams = getSearchParams();

  if (searchParams.has('userId')) {
    userId = searchParams.get('userId');
    if (Platform.OS === 'web') {
      sessionStorage.setItem('overrideUserId', userId as string);
    } else {
      globalThis.overrideUserId = userId;
    }
  }

  const logoutOverrideUser = () => {
    if (Platform.OS === 'web') {
      sessionStorage.removeItem('overrideUserId');
      window.location.reload();
    } else {
      delete (globalThis as any).overrideUserId;
      if (typeof global !== 'undefined') {
        delete (global as any).overrideUserId;
      }
      (global as any).restartApp?.();
    }
  };

  // Check Hermes global context across globalThis and global
  const nativeOverrideId =
    typeof globalThis !== 'undefined' && globalThis.overrideUserId
      ? globalThis.overrideUserId
      : typeof global !== 'undefined'
      ? (global as any).overrideUserId
      : undefined;

  const output = {
    userId:
      userId ||
      (Platform.OS === 'web'
        ? sessionStorage.getItem('overrideUserId')
        : nativeOverrideId),
    logoutOverrideUser,
  };

  return output;
};

function getClerkStateOutsideHooks() {
  const clerkInstance = clerk.getClerkObject();
  
  if (!clerkInstance) {
    return { isLoaded: false, isSignedIn: false, userId: null, getToken: null };
  }

  return {
    isLoaded: true, // If instance exists, it is loaded
    isSignedIn: !!clerkInstance.session,
    userId: clerkInstance.user?.id || null,
    getToken: async (options) => {
      return await clerkInstance.session?.getToken(options);
    },
    signOut: clerkInstance.signOut
  };
}

export const useAuth: typeof clerk['useAuth'] = (initialAuthStateOrOptions) => {
  const overrideObj = useOverrideUserId();
  const auth = { 
    ...getClerkStateOutsideHooks()
    //...clerk.useAuth(initialAuthStateOrOptions)
  };
  if(overrideObj?.userId && auth.isLoaded && auth.isSignedIn) {
    auth.userId = overrideObj?.userId;
  }
  return auth as any;
};

export const useUser: typeof clerk['useUser'] = () => {
  const overrideObj = useOverrideUserId();
  let user = { ...clerk.useUser(), isOverrideUser: false, logoutOverrideUser: () => {} };
  if (overrideObj?.userId && user.isLoaded && user.isSignedIn) {
    user.user = { ...user.user, id: overrideObj?.userId };
    user.isOverrideUser = true;
    user.logoutOverrideUser = overrideObj?.logoutOverrideUser;
  }
  return user;
};